import { render, staticRenderFns } from "./role.vue?vue&type=template&id=60dc718d&scoped=true&"
import script from "./role.vue?vue&type=script&lang=js&"
export * from "./role.vue?vue&type=script&lang=js&"
import style0 from "./role.vue?vue&type=style&index=0&id=60dc718d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dc718d",
  null
  
)

export default component.exports